import { fork, call } from 'redux-saga/effects';

/** Patient Portal */
import * as refillsAvailableMedications from './patientPortal/refills-available-medications-req';
import * as medicationRefillsHistory from './patientPortal/medication-refills-history';
import * as patientChannelsForShare from './patientPortal/patient-channels-for-share';
import * as socialChannelsForShare from './patientPortal/social-channels-for-share';
import * as setPreferredPharmacy from './patientPortal/set-preferred-pharmacy-req';
import * as availableCategories from './patientPortal/available-categories';
import * as labResultHistory from './patientPortal/lab-result-history-req';
import * as medicationRefill from './patientPortal/medication-refill-req';
import * as labTestResults from './patientPortal/lab-test-results-req';
import * as resultsDetails from './patientPortal/results-details-req';
import * as socialHistory from './patientPortal/social-history-req';
import * as loggingAction from './patientPortal/logging-action-req';
import * as immunizations from './patientPortal/immunizations-req';
import * as shareToEmail from './patientPortal/share-to-email-req';
import * as healthRecord from './patientPortal/health-record-req';
import * as shareToChat from './patientPortal/share-to-chat-req';
import * as familyHistory from './patientPortal/family-history';
import * as activityLog from './patientPortal/activity-log-req';
import * as medications from './patientPortal/medications-req';
import * as encounters from './patientPortal/encounters-req';
import * as procedures from './patientPortal/procedures-req';
import * as conditions from './patientPortal/conditions-req';
import * as allergies from './patientPortal/allergies-req';
import medicationRefillsSaga from './sagas/medication-refill-saga';
import shareToChatSaga from './patientPortal/share-to-chat-saga';

import * as confirmVisitByPatient from './requests/confirm-visit-by-patient-req';
import * as inviteGuest from './requests/invite-guest-to-virtual-room-req';
import * as cancelInviteGuest from './requests/cancel-invitation-to-virtual-room-req';
import * as completeCarePlanTask from './requests/complete-care-plan-task-req';
import * as historyAppointments from './requests/appointments-history-req';
import * as upcomingAppointments from './requests/appointments-upcomming-req';
import * as providerHistoryAppointments from './requests/virtual-appointments-history-req';
import * as providerUpcomingAppointments from './requests/virtual-appointments-upcomming-req';
import * as checkinAppointment from './requests/check-in-appointment-req';
import * as cancelAppointment from './requests/cancel-appointment-req';
import * as couponVerification from './requests/coupon-verification-req';
import * as couponCalculation from './requests/coupon-price-calculation-req';
import * as paymentOrder from './requests/payment-order-req';
import * as paymentVerifications from './requests/payment-verifications-req';
import * as payaRedirection from './requests/paya-redirection-req';
import * as editPayment from './requests/edit-payment-req';
import * as statusChanges from './requests/status-change-req';
import * as statusUrgentVisitChanges from './requests/status-urgent-visit-change-req';
import * as networkTestCredentials from './requests/network-test-credentials-req';
import * as roomInvitationJoin from './requests/room-invitation-join-req';
import * as roomInvitationInfo from './requests/room-invitation-info-req';
import * as joinByVisitCode from './requests/join-by-visit-code-req';
import * as connectionRoomJoin from './requests/connection-room-join-req';
import * as uploadDocument from './requests/upload-document-req';
import * as deleteDocument from './requests/delete-document-req';
import * as scheduledTasks from './requests/scheduled-tasks-upcoming-req';
import * as completedTasks from './requests/scheduled-tasks-completed-req';
import * as completeTask from './requests/complete-task-req';
import * as completeTaskCustom from './requests/complete-task-custom-req';
import * as signAppointmentConsent from './requests/sign-appointment-consent-req';
import * as geoLocations from './requests/get-geoLocations-req';
import * as managePendingRequest from './requests/manage-pending-request';
import providerAppointmentListPagination from './sagas/provider-appointment-list-pagination';
import changeAppointmentStatusSaga from './sagas/change-status-saga';
import roomInvitationJoinSaga from './sagas/room-invitation-join-saga';
import appointmentListPagination from './sagas/appointment-list-pagination';
import scheduledTasksPagination from './sagas/scheduled-tasks-pagination';
import completedTasksPagination from './sagas/completed-tasks-pagination';
import {
  healthboardCancelSaga,
  messagesAppointmentCancelSaga,
} from './sagas/cancel-appointment-saga';
import manageTodoSaga from './sagas/manage-todo-saga';
import validateHealthBoardSaga from './sagas/validate-healthboard-saga';
import uploadDocumentSaga from './sagas/upload-document-saga';
import deleteDocumentSaga from './sagas/delete-document-saga';
import acceptedConsent from './sagas/accepted-consent';
import paymentSaga from './sagas/payment-saga';
import managePending from './sagas/manage-pending';
import inviteGuestSaga from './sagas/invite-quest-to-virtual-room-saga';
import cancelInvitationSaga from './sagas/cancel-invitation-to-virtual-visit-saga';
import activityLogLoadMoreSaga from './sagas/activity-log-load-more';
import confirmVisitByPatientSaga from './sagas/confirm-visit-by-patient';
import { watchTestCallModalOpen } from './sagas/test-call-in-popup-saga';

export function* handleInvitationsSaga() {
  yield fork(manageTodoSaga);
  yield call(validateHealthBoardSaga);
}

export function* handleAppoiintmnetStatusChangeSaga() {
  yield fork(managePending);
}

export function* handleHealthBoardCancelAppoinntmentSaga() {
  yield fork(healthboardCancelSaga);
}

export function* handleMessagesCancelAppointmentSaga() {
  yield fork(messagesAppointmentCancelSaga);
}

export default function* healthboardRootSaga() {
  // patient
  yield fork(historyAppointments.watcher);
  yield fork(historyAppointments.paginationWatcher);
  yield fork(upcomingAppointments.watcher);
  yield fork(upcomingAppointments.paginationWatcher);
  // provider
  yield fork(providerHistoryAppointments.watcher);
  yield fork(providerHistoryAppointments.paginationWatcher);
  yield fork(providerUpcomingAppointments.watcher);
  yield fork(providerUpcomingAppointments.paginationWatcher);
  // rest
  yield fork(completeCarePlanTask.watcher);
  yield fork(scheduledTasks.watcher);
  yield fork(scheduledTasks.paginationWatcher);
  yield fork(completedTasks.watcher);
  yield fork(completedTasks.paginationWatcher);
  yield fork(checkinAppointment.watcher);
  yield fork(cancelAppointment.watcher);
  yield fork(couponVerification.watcher);
  yield fork(couponCalculation.watcher);
  yield fork(paymentOrder.watcher);
  yield fork(paymentVerifications.watcher);
  yield fork(payaRedirection.watcher);
  yield fork(statusChanges.watcher);
  yield fork(statusUrgentVisitChanges.watcher);
  yield fork(editPayment.watcher);
  yield fork(uploadDocument.watcher);
  yield fork(deleteDocument.watcher);
  yield fork(signAppointmentConsent.watcher);
  yield fork(completeTaskCustom.watcher);
  yield fork(completeTask.watcher);
  yield fork(geoLocations.watcher);
  yield fork(roomInvitationInfo.watcher);
  yield fork(roomInvitationJoin.watcher);
  yield fork(joinByVisitCode.watcher);
  yield fork(connectionRoomJoin.watcher);
  yield fork(networkTestCredentials.watcher);
  yield fork(managePendingRequest.watcher);
  yield fork(providerAppointmentListPagination);
  yield fork(changeAppointmentStatusSaga);
  yield fork(appointmentListPagination);
  yield fork(scheduledTasksPagination);
  yield fork(completedTasksPagination);
  yield fork(roomInvitationJoinSaga);
  yield fork(uploadDocumentSaga);
  yield fork(deleteDocumentSaga);
  yield fork(acceptedConsent);
  yield fork(paymentSaga);
  yield fork(activityLogLoadMoreSaga);
  // patientPortal
  yield fork(medicationRefillsSaga);
  yield fork(shareToChatSaga);
  yield fork(refillsAvailableMedications.watcher);
  yield fork(medicationRefillsHistory.watcher);
  yield fork(patientChannelsForShare.watcher);
  yield fork(socialChannelsForShare.watcher);
  yield fork(setPreferredPharmacy.watcher);
  yield fork(availableCategories.watcher);
  yield fork(labResultHistory.watcher);
  yield fork(medicationRefill.watcher);
  yield fork(labTestResults.watcher);
  yield fork(resultsDetails.watcher);
  yield fork(immunizations.watcher);
  yield fork(socialHistory.watcher);
  yield fork(familyHistory.watcher);
  yield fork(loggingAction.watcher);
  yield fork(healthRecord.watcher);
  yield fork(shareToEmail.watcher);
  yield fork(medications.watcher);
  yield fork(shareToChat.watcher);
  yield fork(activityLog.watcher);
  yield fork(encounters.watcher);
  yield fork(procedures.watcher);
  yield fork(conditions.watcher);
  yield fork(allergies.watcher);
  // invite guest to virtual room
  yield fork(inviteGuest.watcher);
  yield fork(inviteGuestSaga);
  yield fork(cancelInviteGuest.watcher);
  yield fork(cancelInvitationSaga);
  // confirm virtual visit by patient
  yield fork(confirmVisitByPatient.watcher);
  yield fork(confirmVisitByPatientSaga);
  yield fork(watchTestCallModalOpen);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/root-saga.js